import React, { useState } from 'react';
import RefundRequestAdminList from './components/RefundRequestAdminList';
import { Box, Tabs, Tab } from '@mui/material';

const AdminRefundRequestPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="Refund Requests admin tabs">
        <Tab label="All Requests" />
        <Tab label="Pending" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <RefundRequestAdminList />}
        {tab === 1 && <RefundRequestAdminList statusFilter="pending" />}
      </Box>
    </Box>
  );
};

export default AdminRefundRequestPage;
